import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新发布
            </h2>
            <p className="text-sm text-foreground-600">
              持续更新，为您呈现最新的国产原创精品内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/wenxue"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 border border-background-300/60 text-foreground-700 font-medium text-sm hover:bg-background-100 hover:border-primary-300/50 transition-all cursor-pointer whitespace-nowrap"
          >
            浏览更多内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}